<div class="epds_mat_override" fxLayout="column">
  <form #f="ngForm" (ngSubmit)="searchProtestInfo(f.value)" fxLayout="row wrap" role="search">
    <mat-card appearance="outlined" fxFlex="100">
      <mat-card-header fxLayoutAlign="center">
        <mat-card-title aria-level="1" role="heading">Filters</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" [hidden]="hideSearchFilters">
        <div fxFlex="50" fxFlex.lt-md="100%" fxLayout="column" fxLayoutGap="8px">
          <div fxLayout="row" fxLayoutGap="8px" fxFlex>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>File/B#</mat-label>
              <input [(ngModel)]="stateService.adv_search_bNo" matInput name="b_No" ngModel type="text">
              <button (click)="stateService.adv_search_bNo=undefined" *ngIf="stateService.adv_search_bNo"
                      aria-label="Clear" mat-icon-button matSuffix>
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>EPDS Ctrl #</mat-label>
              <input [(ngModel)]="stateService.adv_search_aNo" matInput name="a_No" ngModel type="text">
              <button (click)="stateService.adv_search_aNo=undefined" *ngIf="stateService.adv_search_aNo"
                      aria-label="Clear" mat-icon-button matSuffix>
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <mat-form-field *ngIf="!audit" appearance="outline" floatLabel="always">
            <mat-label>Solicitation Number</mat-label>
            <input [(ngModel)]="stateService.adv_search_solicitationNo" matInput name="solicitation_No" ngModel
                   type="text">
            <button (click)="stateService.adv_search_solicitationNo=undefined"
                    *ngIf="stateService.adv_search_solicitationNo" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field *ngIf="!audit" appearance="outline" floatLabel="always">
            <mat-label>Protester</mat-label>
            <input [(ngModel)]="stateService.adv_search_companyName" [maxLength]="200" matInput name="company_Name"
                   ngModel type="text">
            <button (click)="stateService.adv_search_companyName=undefined"
                    *ngIf="stateService.adv_search_companyName" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <div fxLayout="row" fxLayoutGap="8px">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>Submission Date From</mat-label>
              <input #subDateFrom [(ngModel)]="stateService.adv_search_submissionFromDate" [matDatepicker]="submissionFromDate"
                     matInput name="startSubmission_Date" (dateChange)="onSubDateChange($event)">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <div matSuffix fxLayout="row">
                <button (click)="stateService.adv_search_submissionFromDate=undefined;onSubDateChange($event)"
                        *ngIf="stateService.adv_search_submissionFromDate" aria-label="Clear" mat-icon-button>
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle [for]="submissionFromDate" ></mat-datepicker-toggle>
              </div>
              <mat-datepicker #submissionFromDate></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>Submission Date To</mat-label>
              <input #subDateTo [(ngModel)]="stateService.adv_search_submissionToDate" [matDatepicker]="submissionToDate"
                     matInput name="endSubmission_Date" (dateChange)="onSubDateChange($event)">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <div matSuffix fxLayout="row">
                <button (click)="stateService.adv_search_submissionToDate=undefined;onSubDateChange($event)"
                        *ngIf="stateService.adv_search_submissionToDate" aria-label="Clear" mat-icon-button>
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle [for]="submissionToDate" matSuffix></mat-datepicker-toggle>
              </div>
              <mat-datepicker #submissionToDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="color_warn" *ngIf="showSubDateError">
            Submission Date From must be before Submission Date To
          </div>

          <div fxLayout="row" fxLayoutGap="8px">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>Due Date From</mat-label>
              <input #dueDateFrom [(ngModel)]="stateService.adv_search_dueFromDate" [matDatepicker]="dueFromDate" matInput
                     name="startDue_Date" (dateChange)="onDueDateChange($event)">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <div matSuffix fxLayout="row">
                <button (click)="stateService.adv_search_dueFromDate=undefined;onDueDateChange($event)"
                        *ngIf="stateService.adv_search_dueFromDate" aria-label="Clear" mat-icon-button>
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle [for]="dueFromDate" matSuffix></mat-datepicker-toggle>
              </div>
              <mat-datepicker #dueFromDate></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>Due Date To</mat-label>
              <input #dueDateTo [(ngModel)]="stateService.adv_search_dueToDate" [matDatepicker]="dueToDate" matInput
                     name="endDue_Date" (dateChange)="onDueDateChange($event)">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <div matSuffix fxLayout="row">
                <button (click)="stateService.adv_search_dueToDate=undefined;onDueDateChange($event)"
                        *ngIf="stateService.adv_search_dueToDate" aria-label="Clear" mat-icon-button>
                  <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker-toggle [for]="dueToDate" matSuffix></mat-datepicker-toggle>
              </div>
              <mat-datepicker #dueToDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="color_warn" *ngIf="showDueDateError">
            Due Date From must be before Due Date To
          </div>

          <mat-form-field *ngIf="!audit" appearance="outline" floatLabel="always">
            <mat-label>Party Information</mat-label>
            <input [(ngModel)]="stateService.adv_search_partyInfo" matInput name="partyInfo" ngModel type="text">
            <!-- matTooltip="Enter Party Information Ex: email,phone number, first name, last name, firm Name" -->
            <button (click)="stateService.adv_search_partyInfo=undefined" *ngIf="stateService.adv_search_partyInfo"
                    aria-label="Clear" mat-icon-button
                    matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field *ngIf="!audit" appearance="outline" floatLabel="always">
            <mat-label>Intervenor Company Name</mat-label>
            <input [(ngModel)]="stateService.adv_search_intervenorCompName" [maxLength]="320" matInput
                   name="intervenorCompName" ngModel type="text">
            <button (click)="stateService.adv_search_intervenorCompName=undefined"
                    *ngIf="stateService.adv_search_intervenorCompName" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div *ngIf="!audit" fxFlex="50" fxFlex.lt-md="100%" fxLayout="column" fxLayoutGap="8px">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Attorney</mat-label>
            <mat-select name="attorneyId" ngModel panelClass="epds-select-override"
                        [(ngModel)]="stateService.adv_search_selectedAttorney">
              <mat-option *ngFor="let key of attorneyList" [value]="key.user_Id">{{key.last_Name + ', ' + key.first_Name}}</mat-option>
            </mat-select>
            <button (click)="stateService.adv_search_selectedAttorney=undefined; $event.stopPropagation()"
                    *ngIf="stateService.adv_search_selectedAttorney" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Case Status</mat-label>
            <mat-select name="case_Status" ngModel panelClass="epds-select-override"
                        [(ngModel)]="stateService.adv_search_selectedCaseStatus">
              <mat-option *ngFor="let key of caseStatuses" [value]="key.value">{{key.text}}</mat-option>
            </mat-select>
            <button (click)="stateService.adv_search_selectedCaseStatus=undefined; $event.stopPropagation()"
                    *ngIf="stateService.adv_search_selectedCaseStatus" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Law Group</mat-label>
            <mat-select name="lawGroup" ngModel panelClass="epds-select-override"
                        [(ngModel)]="stateService.adv_search_selectedLawGroup" >
              <mat-option *ngFor="let key of groupNoList" [value]="key">Group {{key}}</mat-option>
            </mat-select>
            <button (click)="stateService.adv_search_selectedLawGroup=undefined; $event.stopPropagation()"
                    *ngIf="stateService.adv_search_selectedLawGroup" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Case Type</mat-label>
            <mat-select name="caseType" ngModel panelClass="epds-select-override"
                        [(ngModel)]="stateService.adv_search_selectedCaseType">
              <mat-option *ngFor="let key of caseTypes" [value]="key.value">{{key.text}}</mat-option>
            </mat-select>
            <button (click)="stateService.adv_search_selectedCaseType=undefined; $event.stopPropagation()"
                    *ngIf="stateService.adv_search_selectedCaseType" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <app-agency #agencies [layout]="'column'" (agencies)="onSelectedAgencies($event)" [tier2Required]="false"
                      [closeBtn]="true" [(t1State)]="stateService.adv_search_t1Agency" [(t2State)]="stateService.adv_search_t2Agency"></app-agency>

        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
        <div fxFlex="50">
          <button (click)="onExport()" [disabled]="!dataSource.data.length" color="accent" mat-raised-button
                  type="button">Export
          </button>
          <div fxFlex=""></div>
          <button color="primary" mat-raised-button type="submit" [disabled]="disableSearch || searching" class="spinner-black">
            <div *appSpinner="searching"></div>
            Search
          </button>
        </div>
        <div fxFlex="50">
          <button color="accent" mat-raised-button type="reset" (click)="onReset()">Reset</button>
          <div fxFlex=""></div>
          <button color="accent" mat-raised-button type="button" (click)="onToggleSearchFilters()">Toggle Filters</button>
        </div>
      </mat-card-actions>
    </mat-card>
  </form>
  <mat-card appearance="outlined">
    <mat-card-content class="mat-elevation-z8 no-bottom-pad" fxLayout="column">
      <div fxLayout>
        <div fxLayoutAlign="start" fxFlex="20">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput type="text" (keyup)="applyFilter($event)" #filterInput>
            <button mat-icon-button *ngIf="filterInput.value" matSuffix aria-label="Clear"
                    (click)="filterInput.value='';applyFilter($event); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div fxFlex="80" fxLayoutAlign="end">
          <mat-paginator appPaginationSave [lsKey]="'adv_search_page_size'" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                         showFirstLastButtons aria-label="Select page of users" ></mat-paginator>
        </div>
      </div>
      <div class="scrollable-content">
        <table mat-table matSort [dataSource]="dataSource" (matSortChange)="util.announceSortChange($event)"
               [matSortActive]="defaultSortColumn" matSortDirection="asc">
          <ng-container matColumnDef="a_No">
            <th *matHeaderCellDef aria-label="A-Number : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="A-Number : activate to sort column ascending">A-Number
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.a_No}} </td>
          </ng-container>
          <ng-container matColumnDef="b_No">
            <th *matHeaderCellDef aria-label="B-Number : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="B-Number : activate to sort column ascending">B-Number
            </th>
            <td *matCellDef="let protest" mat-cell>
              <app-dashboard-tree [protestParent]="protest"></app-dashboard-tree>
            </td>
          </ng-container>
          <ng-container matColumnDef="company_Name">
            <th *matHeaderCellDef aria-label="Protester : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Protester : activate to sort column ascending">Protester
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.company_Name}} </td>
          </ng-container>
          <ng-container matColumnDef="submission_Date">
            <th *matHeaderCellDef aria-label="Filing Date : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Filing Date : activate to sort column ascending">Filing Date
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.submission_Date}} </td>
          </ng-container>
          <ng-container matColumnDef="agency_Name">
            <th *matHeaderCellDef aria-label="Agency : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Agency : activate to sort column ascending">Agency
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.agency_Name}} </td>
          </ng-container>
          <ng-container matColumnDef="solicitation_No">
            <th *matHeaderCellDef aria-label="Solicitation Number : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Solicitation Number : activate to sort column ascending">Solicitation Number
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.solicitation_No}} </td>
          </ng-container>
          <ng-container matColumnDef="due_Date">
            <th *matHeaderCellDef aria-label="Due Date : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Due Date : activate to sort column ascending">Due Date
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.due_Date}} </td>
          </ng-container>
          <ng-container matColumnDef="attorney_Group_Id">
            <th *matHeaderCellDef aria-label="Group # : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Group # : activate to sort column ascending">Group #
            </th>
            <td *matCellDef="let protest" mat-cell> Group {{protest.attorney_Group_Id}} </td>
          </ng-container>
          <ng-container matColumnDef="attorney_Name">
            <th *matHeaderCellDef aria-label="Attorney Name : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Attorney Name : activate to sort column ascending">Attorney Name
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.attorney_Name}} </td>
          </ng-container>
          <ng-container matColumnDef="case_Type">
            <th *matHeaderCellDef aria-label="Case Type : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Case Type : activate to sort column ascending">Case Type
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.case_Type | uppercase}} </td>
          </ng-container>
          <ng-container matColumnDef="pay_dot_gov_id">
            <th *matHeaderCellDef aria-label="Pay.gov Tracking Id : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Pay.gov Tracking Id : activate to sort column ascending">Pay.gov Tracking Id
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.pay_dot_gov_id}} </td>
          </ng-container>
          <ng-container matColumnDef="transaction_Amount">
            <th *matHeaderCellDef aria-label="Transaction Amount : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Transaction Amount : activate to sort column ascending">Transaction Amount
            </th>
            <td *matCellDef="let protest" mat-cell>{{protest.transaction_Amount}}</td>
          </ng-container>
          <ng-container matColumnDef="case_Status">
            <th *matHeaderCellDef aria-label="Case Status : activate to sort column ascending" mat-header-cell
                mat-sort-header sortActionDescription="Case Status : activate to sort column ascending">Case Status
            </th>
            <td *matCellDef="let protest" mat-cell> {{protest.case_Status}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">No data or nothing that matches the filter "{{filterInput.value}}"</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
